import GhHtmlElement from '@gudhub/gh-html-element';
import html from './itemSideBarItem.html';
import { getItemTitle, getItemDeepLink, checkCurrentUserAppAccess } from '../../../itemRef.js';

class GhItemSideBarItem extends GhHtmlElement {

    constructor() {
        super();
        this.itemTitle = null;
        this.hasAccess = false;
    }

    async connectedCallback() {
        this.getAttributes();

        super.render(html);

        this.hasAccess = await checkCurrentUserAppAccess(this.appId);

        if(this.hasAccess) {
            this.itemTitle = await getItemTitle(this.appId, this.itemId);
        } else {
            this.itemTitle = 'Unavailable';
            this.classList.add('users_sidebar__user--disabled');
        }

        super.render(html);

        if(this.hasAccess) {
            this.addEventListener('click', (event) => {
                if(event.target.closest('.users_sidebar__item_open_btn')) {
                    this.openItem();
                    return;
                }

                const conversations = this.closest('gudhub-messenger');
                if(conversations && !conversations.classList.contains('conversations--expanded')) {
                    conversations.setExpanded(true);
                }
                this.closest('gh-users-side-bar').selectItemDiscussion(this, this.conversationId, {
                    app_id: this.appId,
                    item_id: this.itemId,
                    view_id: this.viewId
                });
            });
        }
    }

    //********************* OPEN ITEM ********************************//
    // "Open item" row button - navigates the app to this item's open_item
    // route, same pattern as gh-direct-message-chat's openItem().
    openItem() {
        const $location = gudhub.ghconstructor.angularInjector.get('$location');
        const $rootScope = gudhub.ghconstructor.angularInjector.get('$rootScope');

        const messenger = this.closest('gudhub-messenger');
        if(messenger?.isMobile()) {
            messenger.setMobileTab('apps');
            messenger.setExpanded(false);
        }

        $location.path(getItemDeepLink(this.appId, this.viewId, this.itemId));
        $rootScope.$apply();
    }

    getAttributes() {
        this.conversationId = this.getAttribute('conversation-id');
        this.appId = this.getAttribute('app-id');
        this.itemId = this.getAttribute('item-id');
        this.viewId = this.getAttribute('view-id') || null;
        this.unreadCount = Number(this.getAttribute('unread-count')) || 0;
    }

    //********************* SET UNREAD COUNT ********************************//
    // Updates this item's unread badge in place, without a full re-render.
    // * count (number) — new unread count; the badge is removed when 0
    setUnreadCount(count) {
        this.unreadCount = count;

        let badge = this.querySelector('.users_sidebar__unread_badge');

        if(count > 0) {
            if(!badge) {
                badge = document.createElement('span');
                badge.className = 'users_sidebar__unread_badge';
                this.appendChild(badge);
            }
            badge.textContent = count;
        } else {
            badge?.remove();
        }
    }
}

if(!customElements.get('gh-item-side-bar-item')){
    customElements.define('gh-item-side-bar-item', GhItemSideBarItem);
}
